export type SelectOption<Value = string> = {
  label: string;
  value: Value;
  disabled?: boolean;
  hidden?: boolean;
};

export type IModal = {
  show: boolean;
  header: string;
  body: string;
  showCancel?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
};

export enum ThemeColors {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Danger = 'danger',
  Success = 'success',
  Muted = 'muted',
  Info = 'info',
  Warning = 'warning',
  Transparent = 'transparent',
  Dark = 'dark',
}

export enum ComponentSizes {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
  None = 'none',
}

export type Tag = {
  key: string;
  value: string;
};

export type WeekDays = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type WeekNames = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export type PartialFields<T extends { [key: string]: unknown }, Fields extends keyof T> = Partial<Pick<T, Fields>> & Omit<T, Fields>;

export type PromiseType<T> = T extends Promise<infer U> ? U : T;

export type ArrayType<T> = T extends (infer U)[] ? U : T;

export type ArrayFromStrings<Options extends string> = {
  [Item in Options]: Exclude<Options, Item> extends never ? [Item] : [...ArrayFromStrings<Exclude<Options, Item>>, Item];
}[Options];
